import React, { type FC, type PropsWithChildren } from 'react';

import { ABTesting } from '../../../modules/ab-testing';

export interface ABTestPPCRedirectProps {
  willTriggerFire?: boolean;
}

const ABTestPPCRedirect: FC<PropsWithChildren<ABTestPPCRedirectProps>> = ({ willTriggerFire }) => (
  <ABTesting.Component.Base
    isAboveTheFold
    branchesToRender={['T_A', 'T_B']}
    testName="FY26_LucidchartFlowchartRevisit"
    trigger="redirect"
    willTriggerFire={willTriggerFire}
  >
    <ABTesting.Component.Branch
      branch="T_B"
      redirectPath="https://lucidchart.com/pages/landing/flowchart-software-ab"
    />
  </ABTesting.Component.Base>
);

export default ABTestPPCRedirect;
